import { TextField } from '@usealloy/component-library';
import styled from 'styled-components';

export const StyledDatePickerWrapper = styled.div`
  width: 100%;

  > div {
    width: 100%;
  }
`;

export const StyledTextField = styled(TextField)`
  && {
    height: var(--cl-space-10);
  }
`;

export const StyledErrorText = styled.div`
  color: var(--cl-red-500);
  font-size: var(--cl-font-size-1);
`;
